import comp from "./HeadingText";
export default comp;
